import { observer } from 'mobx-react-lite'
import { type ReactElement, useMemo } from 'react'
import { ContactsPageComponent } from 'app/components/contacts-page/ContactsPageComponent'
import { useContactsPage } from 'app/components/contacts-page/useContactsPage'
import { ListKindLine } from 'app/components/lists/ListKindLine'
import type { FilterableColumn } from 'app/filter.utils'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import type { SystemListBand, SystemListDef } from 'app/types/navigation'

export const SystemListTable = observer(function SystemListTable({
  def,
  band,
  viewToggle,
  titleActions,
  bandColumn,
}: {
  def: SystemListDef
  band?: SystemListBand
  viewToggle: ReactElement
  titleActions?: ReactElement
  bandColumn?: FilterableColumn
}): ReactElement {
  const props = useContactsPage({ list: def, band })
  const needsActionDateEnabled = !!useFeatureToggle(`needs-action-date`)
  const memoizedFilters = useMemo(
    () => (bandColumn ? [bandColumn, ...props.memoizedFilters] : props.memoizedFilters),
    [bandColumn, props.memoizedFilters],
  )
  return (
    <ContactsPageComponent
      {...props}
      memoizedFilters={memoizedFilters}
      viewToggle={viewToggle}
      titleActions={titleActions}
      newContact={false}
      subheader={<ListKindLine kind="builtIn" />}
      fixedRules={{ source: def.name, rules: def.fixedRules({ needsActionDateEnabled }) }}
    />
  )
})
